export const createDocumentHandleChange = ({ setNewDoc, getIsEditMode }) => {
  return (e) => {
    const { name, type, value, checked, files } = e.target;

    if (name === "file") {
      const selectedFile = files?.[0];

      if (!selectedFile) return;

      const isEditMode =
        typeof getIsEditMode === "function" ? getIsEditMode() : false;

      if (isEditMode) {
        const confirmChange = window.confirm(
          "Mevcut dosyanın üzerine yazılacak, emin misiniz?"
        );

        if (!confirmChange) {
          e.target.value = "";
          return;
        }
      }

      setNewDoc((prev) => ({ ...prev, file: selectedFile }));
      return;
    }

    if (type === "checkbox" || type === "switch") {
      setNewDoc((prev) => ({ ...prev, [name]: checked }));
      return;
    }

    setNewDoc((prev) => ({ ...prev, [name]: value }));
  };
};